export const SET_NEWS_DIGESTS_CATEGORIES_FETCHING = 'SET_NEWS_DIGESTS_CATEGORIES_FETCHING';
export const SET_NEWS_DIGESTS_CATEGORIES_ERROR = 'SET_NEWS_DIGESTS_CATEGORIES_ERROR'
export const SET_NEWS_DIGESTS_ALL_CATEGORIES = 'SET_NEWS_DIGESTS_ALL_CATEGORIES';
export const CLEAN_NEWS_DIGESTS_CATEGORIES = 'CLEAN_NEWS_DIGESTS_CATEGORIES';
export const ABORT_NEWS_DIGESTS_CATEGORIES_REQUEST = 'ABORT_NEWS_DIGESTS_CATEGORIES_REQUEST';



// WEBPACK FOOTER //
// ./src/redux_related/newsDigestsCategories/actions.js